import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import { CardBackButton } from "/imports/ui/components/shared";
import useTrainerClaim from "./useTrainerClaim";
import TrainerClaimAlert from "./components/TrainerClaimAlert";
import TrainerCodeStep from "./components/TrainerCodeStep";
import TrainerPasswordStep from "./components/TrainerPasswordStep";

function TrainerClaimView() {
  const c = useTrainerClaim();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" py={4}>
      <Card sx={{ maxWidth: "31.25rem", width: "100%" }}>
        <CardContent sx={{ p: { xs: 2.5, sm: 4 }, "&:last-child": { pb: { xs: 2.5, sm: 4 } } }}>
          <CardBackButton onClick={c.handleBack} />
          <Typography variant="h5" fontWeight={600} textAlign="center" gutterBottom>
            Trainer sign-in
          </Typography>
          <Typography variant="body2" color="textSecondary" textAlign="center" mb={3}>
            {c.step === "code"
              ? "Enter the staff code your club shared with you."
              : "Set a password to finish. This is the password you'll use everywhere with us."}
          </Typography>

          <TrainerClaimAlert message={c.error || c.authError} errorCode={c.errorCode} loginTo={c.loginTo} />

          {c.step === "code" ? (
            <TrainerCodeStep code={c.code} onCodeChange={c.handleCodeChange} loading={c.loading} errorCode={c.errorCode} onSubmit={c.handleVerify} />
          ) : (
            <TrainerPasswordStep
              prefill={c.prefill}
              password={c.password}
              setPassword={c.setPassword}
              confirmPassword={c.confirmPassword}
              setConfirmPassword={c.setConfirmPassword}
              showPassword={c.showPassword}
              setShowPassword={c.setShowPassword}
              showConfirmPassword={c.showConfirmPassword}
              setShowConfirmPassword={c.setShowConfirmPassword}
              loading={c.loading}
              onSubmit={c.handleClaim}
              onUseDifferentCode={() => c.setStep("code")}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default TrainerClaimView;
